/* One-pack suggestions; Intelligems owns assignment and the checkout discount. */
(() => {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  const existing = window.__petesSamplesUpsellState;
  if (existing) { existing.schedule?.(0); return; }

  const state = window.__petesSamplesUpsellState = { revision: 0, request: null, timer: null, adding: false, status: null, selectedVariantId: '', selectionSource: null, rejectedVariantIds: new Set(), schedule: null, picker: null, closeMenu: null, renderFingerprint: null };
  // AOV 02: only the verified, unconditional USD $1/item offer may change the
  // pre-add display. Never infer a discount from a URL, stored group, or title.
  const SAMPLE_PRICE_TEST = {
    experimentId: '1c224642-d452-4ee9-af0e-10b658b0a6e4',
    treatmentId: '1069d51d-2d04-43de-9da3-f341aeda4201',
    offerId: '3ca7e5a7-88d7-422b-8870-15f519926aee',
  };
  function withOfferPrice(product, cart) {
    try {
      const api = window.igData;
      if (cart?.currency !== 'USD' || Number(product.price) !== 999) return product;
      const experiment = api?.user?.getExperiments()?.find((test) => test.id === SAMPLE_PRICE_TEST.experimentId);
      if (!experiment || api.user.getTestGroup(SAMPLE_PRICE_TEST.experimentId)?.id !== SAMPLE_PRICE_TEST.treatmentId) return product;
      const campaign = (api.offers || api.campaigns)?.getAll()?.find((offer) =>
        (offer.offer || offer.discount)?.id === SAMPLE_PRICE_TEST.offerId);
      const discount = campaign?.offer || campaign?.discount;
      const tier = discount?.tiers?.[0];
      if (!discount
        || discount.isArchived || discount.discountType !== 'dollar'
        || discount.unitType !== 'unit' || discount.maximumDollarDiscount != null
        || discount.subscriptionApplicationType !== 'oneTime'
        || discount.discountApplicationType !== 'cartDiscount'
        || discount.discountApplicationMethod !== 'perItem'
        || discount.tiers.length !== 1 || Number(tier.minimumUnits) !== 0
        || Number(tier.unitDiscount) !== 1 || tier.isFreeShipping || tier.isGiftWithPurchase
        || !(discount.offerProducts || discount.testProducts)?.some((item) => String(item.id) === String(product.id)
          && item.variants?.some((variant) => String(variant.id) === String(product.variantId)))) return product;
      return { ...product, price: 899, priceText: '$8.99 USD', offerId: SAMPLE_PRICE_TEST.offerId };
    } catch (_) {
      // Missing/changed vendor API must leave the ordinary upsell usable.
      return product;
    }
  }
  const VARIETY = {
    'variety-short-lc': ['penne-lc', 'rotini-lc', 'elbows-lc'],
    'variety-long-lc': ['spaghetti-lc', 'linguine-lc', 'fettuccine-lc'],
    'spaghetti-k-lc': ['spaghetti-k', 'spaghetti-lc'],
    'gnocchi-variety': ['gnocchi-pro', 'gnocchi-keto', 'gnocchi-lite'],
    'variety-s': ['penne-lc', 'rotini-lc', 'elbows-lc'],
    'variety-spagheti': ['spaghetti-lc', 'linguine-lc', 'fettuccine-lc'],
    variety: ['spaghetti-k', 'spaghetti-lc'],
    gnocchi: ['gnocchi-pro', 'gnocchi-keto', 'gnocchi-lite'],
  };
  const clean = (value) => String(value || '').trim().toLowerCase()
    .replace(/(?:-|\s)copy(?:-\d+)?$/g, '').replace(/^\d+\s*x\s*/g, '').replace(/\b\d+\s*(?:pack|ct|count)\b/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const skuFamily = (value) => String(value || '').trim().toLowerCase()
    .replace(/[-_]?\d+\s*(?:ct|count)(?:[-_]?shopify)?$/i, '').replace(/[-_]shopify$/i, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const remove = () => { state.closeMenu?.(); drawer.querySelectorAll('[data-petes-upsell-card]').forEach((node) => node.remove()); state.picker = null; state.renderFingerprint = null; };
  const mount = () => drawer.querySelector('[role="dialog"] .flow-root');
  function ensurePlacement() {
    const target = mount();
    const card = drawer.querySelector('[data-petes-upsell-card]');
    // Native drawer renders can move the list without changing the offer data.
    if (target && card && target.nextElementSibling !== card) {
      target.insertAdjacentElement('afterend', card);
    }
  }

  function config() {
    const node = document.querySelector('script[type="application/json"][data-petes-samples-config]');
    if (!node) return null;
    try {
      const value = JSON.parse(node.textContent || '{}');
      if (!value.cartUrl || !value.addUrl || !Array.isArray(value.products)) return null;
      value.labels ||= {};
      return value;
    } catch (error) { console.warn('[Pete\'s Pasta samples] Invalid config', error); return null; }
  }
  function keysForItem(item) {
    const keys = new Set();
    const add = (value) => { const sku = skuFamily(value), name = clean(value); if (sku) keys.add(sku); if (name) keys.add(name); };
    [item.sku, item.handle, item.product_handle, item.product_title, item.title].forEach(add);
    Object.entries(item.properties || {}).forEach(([key, value]) => { if (/flavo(?:u)?r|component|bundle/i.test(key)) add(value); });
    [...keys].forEach((key) => (VARIETY[key] || []).forEach((family) => keys.add(family)));
    return keys;
  }
  function keysForProduct(product) {
    const keys = new Set();
    [product.family, product.handle, product.title, ...(product.familyIds || []), ...(product.aliases || [])].forEach((value) => {
      const sku = skuFamily(value), name = clean(value); if (sku) keys.add(sku); if (name) keys.add(name);
    });
    return keys;
  }
  function eligible(value, cart) {
    const items = (cart.items || []).filter((item) => !item.properties?._petes_subscription_benefit && !/shipping-protection|order-protection/i.test(item.handle || ''));
    if (!items.length) return [];
    return value.products.filter((product) => {
      if (product.available === false || state.rejectedVariantIds.has(String(product.variantId))) return false;
      if (!value.hideExisting) return true;
      const targets = keysForProduct(product);
      return !items.some((item) => {
        if (product.id && String(item.product_id || '') === String(product.id)) return true;
        const present = keysForItem(item);
        return [...targets].some((key) => present.has(key));
      });
    });
  }
  const isSample = (item) => item.properties?._petes_upsell_source === 'minicart';
  function orphanSamples(cart) {
    const items = cart.items || [];
    const hasMainProduct = items.some((item) => !isSample(item)
      && !item.properties?._petes_subscription_benefit
      && !/shipping.protection|order.protection/i.test(`${item.handle || ''} ${item.product_title || item.title || ''}`)
      && Number(item.original_line_price ?? item.final_line_price ?? item.price) > 0);
    return hasMainProduct ? [] : items.filter(isSample);
  }
  async function cleanOrphanSamples(value, cart) {
    if (!orphanSamples(cart).length) return false;
    if (state.cleaning || state.adding || document.querySelector('petes-subscription-benefits')?.syncing) {
      state.schedule(350);
      return true;
    }
    state.cleaning = true;
    let cleaned = false;
    try {
      // Confirm eligibility immediately before a write; never delete from a cached view.
      const fresh = window.PetesCart ? await window.PetesCart.read({ force: true })
        : await (async () => {
          const response = await fetch(value.cartUrl, { cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart unavailable');
          return response.json();
        })();
      const samples = orphanSamples(fresh);
      if (!samples.length) { cleaned = true; return true; }
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: Object.fromEntries(samples.map((item) => [item.key, 0])) }),
      });
      if (!response.ok) throw new Error('Unable to remove the standalone sample');
      cleaned = true;
      state.status = null;
      remove();
      if (mount() && typeof window.updateCart === 'function') await window.updateCart();
      if (location.pathname.replace(/\/$/, '') === `${window.Shopify?.routes?.root || '/'}cart`) location.reload();
      return true;
    } finally {
      state.cleaning = false;
      if (cleaned) state.schedule(350);
    }
  }
  function configuredDefault(value, products) {
    const productId = value.preselectedProductId;
    if (!Number.isFinite(productId) || productId <= 0) return null;
    // If the configured pack is already in the basket or unavailable, select
    // the first eligible alternative. An unset default still means no preselection.
    return products.find((product) => String(product.id) === String(productId)) || products[0] || null;
  }
  function reconcileSelection(value, products) {
    const selected = products.find((product) => String(product.variantId) === state.selectedVariantId);
    // Preserve a shopper's choice only while it is still eligible. Cart changes
    // can remove that shape from the suggestions, so recover the default below.
    if (state.selectionSource === 'shopper' && selected) return;
    const defaultProduct = configuredDefault(value, products);
    if (state.selectionSource === 'default' && selected && defaultProduct && String(selected.variantId) === String(defaultProduct.variantId)) return;
    state.selectedVariantId = defaultProduct ? String(defaultProduct.variantId) : '';
    state.selectionSource = defaultProduct ? 'default' : null;
  }
  function status(node, message, kind) { node.textContent = message || ''; node.hidden = !message; node.dataset.state = kind || ''; }
  function shippingCopy(value, cart, product) {
    const generic = value.labels.description || '';
    const limit = Number(value.shippingWeightLimitGrams);
    if (value.country !== 'US' || value.showShippingClaim === false || !value.labels.shippingDescription || !Number.isFinite(limit) || !Number.isFinite(Number(cart.total_weight))) return generic;
    // Before selection, promise no extra shipping only if every offered pack fits.
    const candidates = product ? [product] : value.products || [];
    const grams = candidates.length ? Math.max(...candidates.map((sample) => Number.isFinite(Number(sample.grams)) ? Number(sample.grams) : limit)) : limit;
    return Number(cart.total_weight || 0) + (Number.isFinite(grams) ? grams : limit) < limit ? value.labels.shippingDescription : generic;
  }
  function render(value, cart, products) {
    const focused = document.activeElement?.classList?.contains('petes-upsell__select') ? 'select'
      : document.activeElement?.classList?.contains('petes-upsell__add') ? 'add' : '';
    reconcileSelection(value, products);
    state.closeMenu?.(); remove();
    const target = mount();
    if (!target || !products.length) return;
    const labels = value.labels;
    const card = document.createElement('aside'); card.className = 'petes-upsell'; card.dataset.petesUpsellCard = 'true'; card.setAttribute('aria-label', labels.heading || 'Try another pasta');
    const heading = document.createElement('h3'); heading.className = 'petes-upsell__heading'; heading.textContent = labels.heading || 'Try another pasta'; card.append(heading);
    const description = document.createElement('p'); description.className = 'petes-upsell__description'; card.append(description);
    const content = document.createElement('div'); content.className = 'petes-upsell__card';
    const header = document.createElement('div'); header.className = 'petes-upsell__header'; header.append(heading, description); content.append(header);
    const imageLink = document.createElement('div'); imageLink.className = 'petes-upsell__image'; imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden', 'true');
    const image = document.createElement('img'); image.loading = 'lazy'; image.alt = ''; imageLink.append(image);
    const details = document.createElement('div'); details.className = 'petes-upsell__details';
    const name = document.createElement('span'); name.className = 'petes-upsell__name';
    const price = document.createElement('span'); price.className = 'petes-upsell__price'; details.append(name, price); imageLink.hidden = true; details.hidden = true; content.append(imageLink, details);
    const picker = document.createElement('div'); picker.className = 'petes-upsell__picker';
    const select = document.createElement('button'); select.className = 'petes-upsell__select'; select.type = 'button'; select.setAttribute('aria-haspopup', 'listbox'); select.setAttribute('aria-expanded', 'false');
    const list = document.createElement('div'); const listId = `petes-upsell-options-${state.revision}`; list.id = listId; list.className = 'petes-upsell__options'; list.hidden = true; list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', labels.choose || 'Choose a 1 pack'); select.setAttribute('aria-controls', listId);
    const options = products.map((product, index) => { const option = document.createElement('button'); option.className = 'petes-upsell__option'; option.type = 'button'; option.id = `${listId}-${index}`; option.setAttribute('role', 'option'); option.dataset.variantId = String(product.variantId); option.textContent = product.title; list.append(option); return option; });
    picker.append(select, list);
    const add = document.createElement('button'); add.className = 'petes-upsell__add'; add.type = 'button'; add.disabled = true;
    const notice = document.createElement('p'); notice.className = 'petes-upsell__status'; notice.hidden = true; notice.setAttribute('role', 'status'); notice.setAttribute('aria-live', 'polite');
    content.append(picker, add); card.append(content, notice); target.insertAdjacentElement('afterend', card); state.picker = picker;
    const selected = () => products.find((product) => String(product.variantId) === state.selectedVariantId);
    let open = false, typeahead = '', typeaheadTimer = null;
    const menuResize = new ResizeObserver(() => { if (open) positionMenu(); });
    const closeMenu = (restoreFocus = false) => { if (!open) return; open = false; menuResize.disconnect(); list.hidden = true; select.setAttribute('aria-expanded', 'false'); if (restoreFocus) select.focus(); };
    const setSelection = (variantId) => { state.status = null; state.selectedVariantId = variantId; state.selectionSource = 'shopper'; sync(); };
    const activeOption = () => options.find((option) => option.dataset.variantId === state.selectedVariantId) || options[0];
    const setActive = (option) => {
      if (!option) return;
      options.forEach((item) => item.tabIndex = item === option ? 0 : -1);
      option.focus({ preventScroll: true });
      // Scroll only the list, never the drawer behind its sticky checkout.
      if (option.offsetTop < list.scrollTop) list.scrollTop = option.offsetTop;
      else if (option.offsetTop + option.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = option.offsetTop + option.offsetHeight - list.clientHeight; };
    const positionMenu = () => {
      // The Navidium checkout can change footer height after the drawer opens.
      // Keep the selector visible and remeasure the space above it when that happens.
      select.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      const scrollArea = card.parentElement;
      const header = scrollArea.querySelector('.sticky');
      const top = Math.max(scrollArea.getBoundingClientRect().top, header?.getBoundingClientRect().bottom || 0);
      list.style.maxHeight = Math.max(44, Math.min(220, picker.getBoundingClientRect().top - top - 8)) + 'px';
    };
    const openMenu = () => {
      if (open) return;
      open = true; list.hidden = false; select.setAttribute('aria-expanded', 'true');
      positionMenu(); setActive(activeOption()); menuResize.observe(card.parentElement);
    };
    state.closeMenu = closeMenu;
    const sync = () => {
      const product = selected(); add.disabled = !product || state.adding; select.disabled = state.adding; select.textContent = product?.title || labels.choose || 'Choose a 1 pack';
      options.forEach((option) => { const chosen = option.dataset.variantId === state.selectedVariantId; option.setAttribute('aria-selected', String(chosen)); option.classList.toggle('is-selected', chosen); });
      add.textContent = (state.adding ? labels.adding : product ? labels.add || 'Add 1 pack · __PRICE__' : labels.addBlank || 'Add 1 pack').replace('__PRICE__', product?.priceText || product?.price || '');
      description.textContent = shippingCopy(value, cart, product);
      imageLink.hidden = !product; details.hidden = !product;
      if (!product) return;
      name.textContent = product.title; price.textContent = product.priceText || product.price || '';
      if (product.image) image.src = product.image; else image.removeAttribute('src');
    };
    select.addEventListener('click', () => open ? closeMenu() : openMenu());
    select.addEventListener('keydown', (event) => {
      const key = event.key; const index = options.findIndex((option) => option.dataset.variantId === state.selectedVariantId);
      if (key === 'ArrowDown' || key === 'ArrowUp') { event.preventDefault(); const nextIndex = !open && index === -1 ? (key === 'ArrowDown' ? 0 : options.length - 1) : Math.max(0, Math.min(options.length - 1, index + (key === 'ArrowDown' ? 1 : -1))); openMenu(); setActive(options[nextIndex]); return; }
      if (key === 'Home' || key === 'End') { event.preventDefault(); openMenu(); setActive(key === 'Home' ? options[0] : options.at(-1)); return; }
      if (key === 'Escape') { event.preventDefault(); closeMenu(); return; }
      if (key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) { typeahead = (typeahead + key).toLowerCase(); clearTimeout(typeaheadTimer); typeaheadTimer = setTimeout(() => { typeahead = ''; }, 500); const match = options.find((option) => option.textContent.trim().toLowerCase().startsWith(typeahead)); if (match) setSelection(match.dataset.variantId); }
    });
    list.addEventListener('keydown', (event) => {
      const current = document.activeElement?.closest?.('.petes-upsell__option') || activeOption(); const index = options.indexOf(current); let next;
      if (event.key === 'ArrowDown') next = options[Math.min(options.length - 1, index + 1)]; else if (event.key === 'ArrowUp') next = options[Math.max(0, index - 1)]; else if (event.key === 'Home') next = options[0]; else if (event.key === 'End') next = options.at(-1);
      if (next) { event.preventDefault(); setActive(next); return; }
      if (event.key === 'Escape') { event.preventDefault(); closeMenu(true); return; }
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); setSelection(current.dataset.variantId); closeMenu(true); return; }
      if (event.key === 'Tab') { if (event.shiftKey) event.preventDefault(); closeMenu(true); return; }
      if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) { typeahead = (typeahead + event.key).toLowerCase(); clearTimeout(typeaheadTimer); typeaheadTimer = setTimeout(() => { typeahead = ''; }, 500); const match = options.find((option) => option.textContent.trim().toLowerCase().startsWith(typeahead)); if (match) { event.preventDefault(); setActive(match); } }
    });
    options.forEach((option) => option.addEventListener('click', () => { setSelection(option.dataset.variantId); closeMenu(true); }));
    add.addEventListener('click', async () => {
      const product = selected(); if (!product || state.adding) return;
      state.adding = true; sync(); add.setAttribute('aria-busy', 'true'); status(notice, '', '');
      let confirmed = false;
      try {
        const response = await fetch(value.addUrl, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: product.variantId, quantity: 1, properties: { _petes_upsell_source: 'minicart' } }) });
        if (!response.ok) {
          state.rejectedVariantIds.add(String(product.variantId));
          const body = await response.json().catch(() => null);
          throw new Error(body?.description || body?.message || labels.error || 'Unable to add this item.');
        }
        confirmed = true; state.selectedVariantId = ''; state.selectionSource = null;
        state.status = { message: (labels.added || 'Added __PRODUCT__ to your basket.').replace('__PRODUCT__', product.title), kind: 'success' };
        try {
          if (typeof window.updateCart === 'function') await Promise.resolve(window.updateCart());
          await refresh(true);
        } catch (error) {
          state.status = { message: labels.refreshError || 'Added to your basket, but we could not refresh it.', kind: 'error' };
          renderStatus(value);
        }
      } catch (error) {
        const message = confirmed ? labels.refreshError : labels.error || 'Unable to add this item.';
        state.status = { message, kind: 'error' };
        if (!confirmed) state.schedule(0);
      }
      finally { state.adding = false; add.removeAttribute('aria-busy'); if (state.status) status(notice, state.status.message, state.status.kind); sync(); state.schedule(0); }
    });
    if (state.status) status(notice, state.status.message, state.status.kind);
    sync();
    if (focused === 'select') select.focus();
    if (focused === 'add' && !add.disabled) add.focus();
  }
  function renderStatus(value) {
    remove();
    const target = mount();
    if (!target || !state.status) return;
    const card = document.createElement('aside'); card.className = 'petes-upsell'; card.dataset.petesUpsellCard = 'true';
    const notice = document.createElement('p'); notice.className = 'petes-upsell__status'; notice.setAttribute('role', 'status'); notice.setAttribute('aria-live', 'polite'); notice.dataset.state = state.status.kind; notice.textContent = state.status.message;
    card.append(notice); target.insertAdjacentElement('afterend', card);
  }
  async function refresh(afterConfirmedAdd = false) {
    const revision = ++state.revision; state.request?.abort(); const value = config();
    if (!value) { remove(); return; }
    state.request = new AbortController();
    try {
      const response = await fetch(value.cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: state.request.signal });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json(); if (revision !== state.revision) return;
      if (await cleanOrphanSamples(value, cart)) return;
      if (!mount()) { remove(); return; }
      if (!cart.items?.length) state.status = null;
      const products = eligible(value, cart).map((product) => withOfferPrice(product, cart));
      if (!products.length && state.status) renderStatus(value);
      else {
        reconcileSelection(value, products);
        const fingerprint = JSON.stringify({ value, cart, products, selectedVariantId: state.selectedVariantId, selectionSource: state.selectionSource, status: state.status, adding: state.adding });
        if (state.renderFingerprint === fingerprint && state.picker?.isConnected) { ensurePlacement(); return; }
        render(value, cart, products);
        state.renderFingerprint = fingerprint;
      }
    } catch (error) {
      if (error?.name === 'AbortError' || revision !== state.revision) return;
      if (afterConfirmedAdd) throw error;
      remove();
    }
  }
  state.schedule = (delay = 150) => { clearTimeout(state.timer); state.timer = setTimeout(refresh, delay); };
  new MutationObserver((records) => {
    ensurePlacement();
    const changedDrawer = records.some((record) => {
      if (record.target.closest?.('[data-petes-upsell-card]')) return false;
      return [...record.addedNodes, ...record.removedNodes]
        .some((node) => node.nodeType !== 1 || !node.matches?.('[data-petes-upsell-card]'));
    });
    if (changedDrawer) state.schedule();
  }).observe(drawer, { childList: true, subtree: true });
  window.addEventListener('petes:cart-mutated', () => state.schedule());
  window.addEventListener('ig:ready', () => state.schedule(0));
  window.addEventListener('pageshow', () => state.schedule(0));
  document.addEventListener('toggle-cart', () => state.schedule());
  document.addEventListener('shopify:section:load', () => state.schedule(0));
  document.addEventListener('shopify:section:unload', () => { remove(); state.schedule(0); });
  document.addEventListener('pointerdown', (event) => { if (state.picker && !state.picker.contains(event.target)) state.closeMenu?.(); });
  state.schedule(0);
})();
